/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Train_NowInputs */

const en_us2_shell_train_now = /** @type {(inputs: Shell_Train_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train now`)
};

const pt_br2_shell_train_now = /** @type {(inputs: Shell_Train_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar agora`)
};

const es_419_shell_train_now = /** @type {(inputs: Shell_Train_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenar ahora`)
};

const pt_pt2_shell_train_now = /** @type {(inputs: Shell_Train_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar agora`)
};

const fr_fr2_shell_train_now = /** @type {(inputs: Shell_Train_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'entraîner`)
};

const de_de2_shell_train_now = /** @type {(inputs: Shell_Train_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt trainieren`)
};

const it_it2_shell_train_now = /** @type {(inputs: Shell_Train_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenati ora`)
};

/**
* | output |
* | --- |
* | "Train now" |
*
* @param {Shell_Train_NowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_train_now = /** @type {((inputs?: Shell_Train_NowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Train_NowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_train_now(inputs)
	if (locale === "es-419") return es_419_shell_train_now(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_train_now(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_train_now(inputs)
	if (locale === "de-DE") return de_de2_shell_train_now(inputs)
	if (locale === "it-IT") return it_it2_shell_train_now(inputs)
	return en_us2_shell_train_now(inputs)
});
export { shell_train_now as "shell.train_now" }